export enum MoneyPotType {
  LePotCommun = 'LePotCommun'
}
